import styled from 'styled-components';

export const StatusTypeOptionContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

export const StatusTypeOptionTextStyled = styled.div`
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  font-size: 12px;
  margin: 4px 0px;
`;
